import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import Select from 'react-select';

const formatOptionLabel = ({ label, hasOpenRequest }) => (
    <span className={hasOpenRequest ? 'text-muted' : undefined}>
        {hasOpenRequest && <span className="mr-1" title="Pending request">⚠</span>}
        {label}
        {hasOpenRequest && <small className="ml-2 text-muted">· Pending request</small>}
    </span>
);

export const ProgramSelector = ({ programs = [], value, onChange, label = 'Program', inputId = 'program-select' }) => {
    const options = programs
        .slice()
        .sort((a, b) => (a.programId ?? 0) - (b.programId ?? 0))
        .map((p) => ({
            value: p.programId,
            label: `${p.programId} - ${p.programFormalName}`,
            hasOpenRequest: p.hasOpenRequest ?? false,
            isDisabled: p.hasOpenRequest ?? false,
        }));

    return (
        <FormGroup>
            <Label for={inputId}>{label} <sup className="text-danger">*</sup></Label>
            <Select
                inputId={inputId}
                options={options}
                value={options.find((o) => o.value === value) ?? null}
                onChange={(opt) => onChange(opt?.value ?? null)}
                formatOptionLabel={formatOptionLabel}
                placeholder="Search programs..."
                isClearable
            />
        </FormGroup>
    );
};
